import { colorCycle, proofItems } from "const/content";
import { Section, SectionLarge } from "styles";

import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
	from { opacity: 0; transform: translateY(8px); }
	to { opacity: 1; transform: translateY(0); }
`;

const Strip = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 12px;
	width: 100%;
`;

const Pill = styled.span`
	background: #fff;
	color: ${({ color }) => color};
	border-radius: 999px;
	padding: 12px 20px;
	font-size: 16px;
	font-weight: 700;
	font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
	transition: transform 0.2s ease, box-shadow 0.2s ease;
	animation: ${fadeIn} 0.5s ease-out;
	animation-delay: ${({ delay }) => delay}ms;
	animation-fill-mode: both;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	}

	@media (max-width: 768px) {
		padding: 10px 16px;
		font-size: 14px;
	}
`;

export default function ProofStrip() {
	return (
		<Section style={{ marginTop: 24 }}>
			<SectionLarge style={{ width: "100%" }}>
				<Strip>
					{proofItems.map((item, index) => (
						<Pill key={item} color={colorCycle[index % colorCycle.length]} delay={index * 60}>
							{item}
						</Pill>
					))}
				</Strip>
			</SectionLarge>
		</Section>
	);
}
